module.exports = __webpack_public_path__ + "img/inco4.fa502229.png";